var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.hide,
          expression: "hide",
        },
      ],
      staticClass: "search-form-wrapper",
    },
    [
      _c("div", { on: { click: _vm.togglePanel } }, [_vm._t("default")], 2),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.open
          ? _c("div", { staticClass: "search-form-panel" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.value,
                    expression: "value",
                  },
                ],
                ref: "search-value",
                attrs: { type: "search", placeholder: _vm.__("Search") },
                domProps: { value: _vm.value },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.value = $event.target.value
                    },
                    _vm.search,
                  ],
                },
              }),
              _vm._v(" "),
              _vm.value
                ? _c(
                    "ul",
                    { staticClass: "results" },
                    [
                      _vm.loading
                        ? _c(
                            "div",
                            { staticClass: "loading" },
                            [
                              _c("sync-loader", {
                                staticClass: "spinner",
                                attrs: { size: 10 },
                              }),
                            ],
                            1
                          )
                        : _vm.results.length > 0
                        ? _vm._l(_vm.results, function (item) {
                            return _c("li", { key: item.id }, [
                              _c(
                                "a",
                                {
                                  attrs: { href: item.url, title: item.title },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(item.title) +
                                      "\n            "
                                  ),
                                  _c("span", { staticClass: "type" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.type) +
                                        "\n            "
                                    ),
                                  ]),
                                ]
                              ),
                            ])
                          })
                        : _vm.results.length === 0
                        ? _c("li", { staticClass: "no-results" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.__("No results")) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/components/SearchForm.vue